import React, { useEffect, useState } from "react";
import { FaDonate, FaShippingFast, FaFileInvoice } from "react-icons/fa";
import "./designationBar.css";
import http from "../../api/http";

export default function DesignationBar({
  apiUrl = "/api/designation",
  className = "",
}) {
  const [items, setItems] = useState([]);
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const { data } = await http.get(apiUrl, { signal: controller.signal });
        const top3 = [...(Array.isArray(data) ? data : [])]
          .sort((a, b) => (a.ID ?? 0) - (b.ID ?? 0))
          .slice(0, 3);
        setItems(top3);
        setState({ loading: false, error: null });
      } catch (err) {
        if (controller.signal.aborted) return;
        setState({
          loading: false,
          error: err?.response?.data?.message || err?.message || "Erreur",
        });
      }
    })();
    return () => controller.abort();
  }, [apiUrl]);

  const icons = [FaDonate, FaShippingFast, FaFileInvoice];

  const renderDesignation = (txt = "") => {
    const words = String(txt).trim().split(/\s+/);
    if (words.length <= 10) return <>{words.join(" ")}</>;
    return (
      <>
        {words.slice(0, 10).join(" ")}
        <br />
        {words.slice(10).join(" ")}
      </>
    );
  };

  if (state.loading) {
    return (
      <div className={`designation-bar skeleton ${className}`}>
        <div className="designation-item"><div className="icon-shimmer" /><span className="text-shimmer" /></div>
        <div className="designation-item hide-on-mobile"><div className="icon-shimmer" /><span className="text-shimmer" /></div>
        <div className="designation-item hide-on-mobile"><div className="icon-shimmer" /><span className="text-shimmer" /></div>
      </div>
    );
  }

  if (state.error) {
    return (
      <div className={`designation-bar ${className}`}>
        <span className="designation-error">Impossible de charger les informations.</span>
      </div>
    );
  }

  return (
    <div className={`designation-bar ${className}`}>
      {items.map((it, idx) => {
        const Icon = icons[idx] || FaFileInvoice;
        return (
          <div className="designation-item" key={it.ID ?? idx}>
            <Icon className="designation-icon" aria-hidden="true" />
            <span className="designation-text">{renderDesignation(it.designation)}</span>
          </div>
        );
      })}
    </div>
  );
}
